module.exports = __webpack_public_path__ + "img/envia.50870799.svg";